import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box, styled, Typography } from '@mui/material';
import { getCollectionHandle } from '../../utils/utils';
import { DesktopMenuItemProps } from '../../models/NavigationMenuItem';
import { DropdownNavigationItem } from './DropdownNavigationItem';
import { Megamenu } from './Megamenu';

const BoxItem = styled(Box)(() => ({
    display: 'flex',
    padding: '14px',
    alignItems: 'center',
    transition: 'background-color 100ms',
    '&.selected': {
        backgroundColor: '#14a3de',
    },
    '&.dropdown': {
        position: 'relative',
    },
}));

const MainLinkStyled = styled(Typography)(({ theme }) => ({
    color: `${theme.palette.primary[400]}`,
    fontSize: '16px',
    fontWeight: '700',
    transition: 'color 100ms',
    '&.selected': {
        color: 'white',
    },
}));

export const CollectionNavigationItem: FC<DesktopMenuItemProps> = (props) => {
    const menuItem = props.menuItem;
    const [selectedMenu, setSelectedMenu] = React.useState<null | HTMLElement>(
        null
    );
    const open = Boolean(selectedMenu);

    const megamenuIds = [
        'gid://shopify/MenuItem/487923581228',
        'gid://shopify/MenuItem/487923613996',
        'gid://shopify/MenuItem/510658609452',
        'gid://shopify/MenuItem/505169543468',
    ];

    const handleClick = () => {
        setSelectedMenu(null);
    };

    return (
        <>
            <BoxItem
                onMouseEnter={(e) => setSelectedMenu(e.currentTarget)}
                onMouseLeave={(e) => setSelectedMenu(null)}
                className={
                    (megamenuIds.indexOf(menuItem.id) == -1
                        ? 'dropdown'
                        : 'megamenu') + (open ? ' selected' : '')
                }
            >
                {menuItem.type == 'COLLECTION' && (
                    <>
                        <Link
                            to={
                                'collections/' +
                                getCollectionHandle(menuItem.url)
                            }
                        >
                            <MainLinkStyled className={open ? 'selected' : ''}>
                                {menuItem.title.toUpperCase()}
                            </MainLinkStyled>
                        </Link>
                        {megamenuIds.indexOf(menuItem.id) > -1 && (
                            <Megamenu
                                menuItem={menuItem.items}
                                anchorEl={selectedMenu}
                                clickHandler={handleClick}
                            />
                        )}
                        {megamenuIds.indexOf(menuItem.id) == -1 &&
                            menuItem.items &&
                            menuItem.items.length > 0 && (
                                <DropdownNavigationItem
                                    menuItem={menuItem.items}
                                    anchorEl={selectedMenu}
                                    clickHandler={handleClick}
                                />
                            )}
                    </>
                )}
                {menuItem.type != 'COLLECTION' && (
                    <a href={menuItem.url}>
                        <MainLinkStyled className={open ? 'selected' : ''}>
                            {menuItem.title.toUpperCase()}
                        </MainLinkStyled>
                    </a>
                )}
            </BoxItem>
        </>
    );
};
